var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownloadIcon = function SvgDownloadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.18842 6.46967C4.48131 6.17678 4.95619 6.17678 5.24908 6.46967L8 9.22059L10.7509 6.46967C11.0438 6.17678 11.5187 6.17678 11.8116 6.46967C12.1045 6.76256 12.1045 7.23744 11.8116 7.53033L8.53033 10.8116C8.23744 11.1045 7.76256 11.1045 7.46967 10.8116L4.18842 7.53033C3.89553 7.23744 3.89553 6.76256 4.18842 6.46967Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.25C8.41421 0.25 8.75 0.585786 8.75 1V10C8.75 10.4142 8.41421 10.75 8 10.75C7.58579 10.75 7.25 10.4142 7.25 10V1C7.25 0.585786 7.58579 0.25 8 0.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 14.875C0.25 14.4608 0.585786 14.125 1 14.125H15C15.4142 14.125 15.75 14.4608 15.75 14.875C15.75 15.2892 15.4142 15.625 15 15.625H1C0.585786 15.625 0.25 15.2892 0.25 14.875Z",
    fill: "white"
  })));
};
export default SvgDownloadIcon;